export enum TechSpendSuperCategoryEnum {
    Hardware = 'Hardware',
    Software = 'Software',
    Services = 'Services',
    Communication = 'Communication'
}